import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

export function MarketWelcome({
  initialBananas,
  feeBps,
  minTradeBananas,
  eventId,
  children,
}: {
  initialBananas: number;
  feeBps: number;
  minTradeBananas: number;
  eventId: string;
  children: React.ReactNode;
}) {
  const key = `market-welcome-seen-${eventId}`;
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (localStorage.getItem(key) === '1') setShow(false);
  }, [key]);

  if (!show) return <>{children}</>;

  return (
    <section className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8">
      <div className="border-primary/20 border-b pb-4">
        <p className="font-mono text-primary/70 text-xs uppercase tracking-wider">
          Bienvenida
        </p>
        <h2 className="font-bold text-2xl text-primary sm:text-3xl">
          Platanus Hack Market 🍌
        </h2>
      </div>

      <div className="mt-6 flex flex-col gap-4">
        <Item label="Saldo inicial">
          Empiezas con{' '}
          <span className="bg-primary px-1.5 py-0.5 font-bold text-background">
            {initialBananas.toLocaleString()} 🍌
          </span>
          .
        </Item>
        <Item label="Compra acciones">
          Apuesta por los proyectos que crees que ganarán. El precio sube con
          cada compra.
        </Item>
        <Item label="Vende cuando quieras">
          A medida que la probabilidad sube puedes vender para asegurar
          ganancias — o mantener.
        </Item>
        <Item label="Resolución">
          Al final, cada acción del proyecto ganador paga{' '}
          <span className="bg-primary px-1.5 py-0.5 font-bold text-background">
            1 🍌
          </span>
          . Las acciones perdedoras no pagan.
        </Item>
        <Item label="Reglas">
          Fee de {(feeBps / 100).toFixed(1)}% por trade. Mínimo{' '}
          <span className="font-mono">{minTradeBananas} 🍌</span>. Quien tenga
          más bananas gana.
        </Item>
      </div>

      <Button
        className="mt-6 w-full rounded-none bg-primary py-6 font-bold text-background text-lg uppercase tracking-wider hover:bg-primary/90"
        onClick={() => {
          localStorage.setItem(key, '1');
          setShow(false);
        }}
      >
        Entrar al mercado
      </Button>
    </section>
  );
}

function Item({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="border-primary border-l-4 pl-4">
      <p className="font-mono text-primary/70 text-xs uppercase tracking-wider">
        {label}
      </p>
      <p className="text-primary text-sm sm:text-base">{children}</p>
    </div>
  );
}
